import { useCallback } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'core/router/useNavigate';
import { BulkRetargetingRoutes } from 'sections/bulk-retargeting-campaigns/routes';
import { CampaignEditorTab, useActiveTab } from './useActiveTab';
import { useDrawer } from '../state/actions/useDrawer';
import { useSaveCampaign } from './useSaveCampaign';

const nextUrl = {
  [CampaignEditorTab.Audience]: BulkRetargetingRoutes.EDIT_CONTENT,
  [CampaignEditorTab.Content]: BulkRetargetingRoutes.EDIT_SCHEDULING,
};

export const useOnSaveAndNext = () => {
  const navigate = useNavigate();
  const activeTab = useActiveTab();
  const { siteId, campaignId } = useParams<{ siteId: string; campaignId: string }>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setDrawerOpen] = useDrawer();
  const { saveCampaign, ...mutation } = useSaveCampaign();

  const onSaveAndNext = useCallback(async () => {
    await saveCampaign();

    if (activeTab === CampaignEditorTab.Scheduling) {
      setDrawerOpen(true);
      return;
    }

    const nextTab = nextUrl[activeTab];

    if (nextTab) {
      navigate(nextUrl[activeTab], { siteId, campaignId });
    }
  }, [saveCampaign, activeTab, setDrawerOpen, navigate, siteId, campaignId]);

  return { onSaveAndNext, ...mutation };
};
